/**
 * Obsolète
 * Suppirmer progressivement ces function pour les intégrer dans global.js
 */

/*===================================
=            Google Maps            =
===================================*/

//import FontFaceObserver from "fontfaceobserver";


window.googleMapsLoaded = false;
window.googleMapsLoadedPromise = new Promise(function(resolve,reject) {
    if (googleMapsLoaded==true) resolve();
    else {
        $(document).on('google-map-loaded', function() {
            resolve();
        })
    }            
});


/** 
 * Cette function est executée lorsque l'API google map est chargée
 */
window.initGMaps = function()
{
    /*
        Initialize a Google Map for each element marked as well (replace "uniqid" by a unique good identifier):
        <div id="js-map-uniqid" class="js-google-maps"></div>
     */

    googleMapsLoaded = true

    var kinougardeMapStyle =
     [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road.highway", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "transit", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit.station", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.bus", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "stylers": [ { "color": "#aad2e3" }, { "visibility": "on" } ] } ]

    var kinougardeMarker = {
        path          : 'm 29.7 90 c 1.35 0 2.61 -0.6 3.51 -1.6 c 0.27 -0.3 6.57 -7.5 12.87 -17.6 c 8.82 -14.1 13.32 -26.5 13.32 -37 c 0 -18.7 -13.32 -33.8 -29.7 -33.8 s -29.7 15.1 -29.7 33.8 c 0 10.5 4.5 23 13.32 37 c 6.39 10.1 12.6 17.3 12.87 17.6 c 0.9 1 2.16 1.6 3.51 1.6 z m -12.69 -59.5 c 0 -8 5.67 -14.5 12.69 -14.5 s 12.69 6.5 12.69 14.5 s -5.67 14.5 -12.69 14.5 s -12.69 -6.5 -12.69 -14.5 z',
        fillColor     : '#D1007F',
        fillOpacity   : 0.8,
        strokeWeight  : 0,
        strokeOpacity : 0.8,
        scale         : 0.35,
        size          : new google.maps.Size(27, 40),
        // size          : new google.maps.Size(29.6, 40),
        anchor        : new google.maps.Point(30.45, 83),
        origin        : new google.maps.Point(0,0)
    };

    window.kinougardeMaps = {
        maps         : {},
        customMarker : kinougardeMarker,
        mapStyle     : kinougardeMapStyle
    };

    var mapElements = $('.js-google-maps');

    $.each(mapElements, function(i, item) {
        var mapID      = '#' + item.id,
            $item      = $(item),
            boundLimit = $item.data('maps-boundlimit') ? $item.data('maps-boundlimit') + 1 : false;

        kinougardeMaps.maps[mapID] = new kMaps({
            // 'debug'        : true,
            'mapElement'   : item,
            'mapOptions'   : {
                center : {lat: 46.830834222916934, lng: 362.0813779296875},
                zoom   : 20,
                streetViewControl: false,
                styles : $(item).hasClass('js-custom-style') ? kinougardeMaps.mapStyle : ''
            },
            'boundLimit'   : boundLimit,
            'customMarker' : kinougardeMaps.customMarker,
            'mcOptions'    : {
                gridSize           : 50,
                maxZoom            : 15,
                minimumClusterSize : 2,
                imagePath          : '/wp-sites/themes/argos-wptm-odtBB1/images/google-maps-cluster/m'
            }
        })

        // Add markers when map is ready
        kinougardeMaps.maps[mapID].addEventListener('map:ready', function() {
            if (typeof kMapsMarkers[mapID] !== 'undefined') {
                kinougardeMaps.maps[mapID].setMarkers(kMapsMarkers[mapID], true);
            }
        });
    });
    
    // Pour les champs ACF type adresse
    $("input.google-autocomplete").each(function(index,element) {
        $(element).InitGoogleMapAutoComplete();
    })

    $(document).trigger("google-map-loaded");
    
    /*
        Geolocation function
     */
    if ('geolocation' in navigator) {
        var geolocButtons = $('.js-kmaps-geoloc');

        $.each(geolocButtons, function(i, btn){
            var $btn = $(btn);

            $btn.on('click', function(ev){
                ev.preventDefault();

                // console.log(ev)

                var $b = $(this);

                navigator.geolocation.getCurrentPosition(function(location) {
                    var location_lat = location.coords.latitude
                    var location_lng = location.coords.longitude
                    var latLng       = new google.maps.LatLng(location_lat, location_lng)
                    var geocoder     = new google.maps.Geocoder()

                    $b.addClass('spinning')

                    geocoder.geocode({'latLng': latLng}, function(results, status) {
                        if (status == google.maps.GeocoderStatus.OK && results.length) {
                            var $location_form          = $b.closest('form')
                            var $location_address       = $('[name="location_address"]', $location_form)
                            var $location_real_address  = $('[name="location_real_address"]', $location_form)
                            var $location_postal_code   = $('[name="location_postal_code"]', $location_form)
                            var $location_locality      = $('[name="location_locality"]', $location_form)
                            var $location_lat           = $('[name="location_lat"]', $location_form)
                            var $location_lng           = $('[name="location_lng"]', $location_form)

                            var location_address = results[0].formatted_address
                            var location_real_address
                            var location_postal_code
                            var location_locality

                            for (var i = 0; i < results[0].address_components.length; i++) {
                                var component = results[0].address_components[i]

                                if (component.types[0] == 'street_number') location_real_address += component.long_name + ' '
                                if (component.types[0] == 'route') location_real_address += component.long_name
                                if (component.types[0] == 'postal_code') location_postal_code = component.long_name
                                if (component.types[0] == 'locality') location_locality = component.long_name
                            }

                            $location_address.val(location_address).attr('value', location_address)
                            $location_real_address.val(location_real_address)
                            $location_postal_code.val(location_postal_code)
                            $location_locality.val(location_locality)
                            $location_lat.val(location_lat)
                            $location_lng.val(location_lng)

                            changePictoLocationField($location_address.get(0))
                        } else alert("Geocoder failed due to: " + status)

                        $b.removeClass('spinning')
                    });
                }, function(error) {
                    // console.warn(error)
                    if(error.PERMISSION_DENIED){
                        alert("Vous avez bloqué la géolocalisation. Veuillez la réactiver ou utiliser le champ de recherche.")
                    }
                });
            });
        });
    } else {
        // console.log('no geoloc')
        $('.js-kmaps-geoloc').addClass('disabled')
        //$('.input-with-icon').find('.input-icon').hide()
    }
}

/*=====  End of Google Maps  ======*/

/**
 * get cookie by name without using a regular expression
 */
var getCookie = function(name) {
	var getCookieValues = function(cookie) {
		var cookieArray = cookie.split('=');
		if (cookieArray[1] != null || cookieArray[1] != undefined) {
		    return cookieArray[1].trim();
		}
		else {
		    return "";
		}
	};

	var getCookieNames = function(cookie) {
		var cookieArray = cookie.split('=');
		if (cookieArray[0] != null || cookieArray[0] != undefined) {
		    return cookieArray[0].trim();
		}
		else {
		    return "";
		}
	};

	var cookies = document.cookie.split(';');
	var cookieValue = cookies.map(getCookieValues)[cookies.map(getCookieNames).indexOf(name)];

	return (cookieValue === undefined) ? null : cookieValue;
};


var hash = window.location.hash
$(window).load(function () {
    if (hash && $(hash).length > 0) {
        var $accordion = $(hash).find('.js-accordion')
        if ($accordion.length) {
            if (!$accordion.hasClass('toggled'))
                $accordion.find('.js-accordion-toggler').click()
        }

        if ( $(hash).length > 0 && $(hash).hasClass('image-with-accordion') ) {
            $(hash).find('.js-accordion').addClass('toggled').end().siblings().find('.js-accordion').removeClass('toggled')
        }
        setTimeout( function () {
            $('html, body').animate({
                scrollTop:$(hash).offset().top - $('header').height()
            }, 'slow');
        }, 500)
    }
});

function mobile_not_alt () {
    var winW = $(window).width()
    if (winW < 980) $('.button.mobile-not-alt').removeClass('alt')
    else $('.button.mobile-not-alt').addClass('alt')
}
mobile_not_alt()
$(window).on('resize', function () {
    mobile_not_alt()
})






$(document).ready(function(){
    //annulation de la touche "tabulation" pour passer à l'étape suivante (sur tout le site)
    // document.onkeydown = function (t) {
    //   if(t.which == 9) {
    //     return false;
    //   }
    // }


    if($(".js-google-maps")){
      $(".js-google-maps").children('').attr("tabindex","-1");
      $("#map img").attr("tabindex","-1");
    }




    var $body = $(document.body);

    $(document.body).on('click', '.link-agency-header', function(ev){
      var $target        = $(ev.currentTarget);
      var $link = $target.data('href');
          window.location.assign($link);
    });
    $(document.body).on('click', '.sticky-banner button.close', function(ev){
        var $target        = $(ev.currentTarget),
            $banner = $target.parent();
            $banner.addClass('hidden');
            sessionStorage.setItem("sticky-banner-closed", true);
    });

    $('.obflink').click(function(e){
        var t = $(this);
        var link = atob(t.data('o'));
        var target = t.data('target');
        if (target == undefined || target == ""){
          window.open(link,"_self");
        }else{
          window.open(link,target);
        }
    });
});

// var openSansFont = new FontFaceObserver('Open Sans');
// var caveatFont = new FontFaceObserver('Caveat');

// openSansFont.load(null, 8000).then(function () {
//     console.info("Font Open Sans Loaded")
//     document.documentElement.className += " open-sans-loaded";
// });

// caveatFont.load(null, 8000).then(function () {
//     console.info("Font Caveat Loaded")
//     document.documentElement.className += " caveat-loaded";
// });